import React, { useState } from 'react';
import CartComponent from '../cart/cartComponent';
import './TopBar.css';
import LoginComponent from './loginComponent';
import SettingsMenu from './settingsMenu';
import SearchBar from "./searchBar";
import LanguageButton from '../../buttons/languageButton';
import ColorModeToggle from '../../buttons/colorModeToggle';
import {Link} from 'react-router-dom';
import { inject, observer } from "mobx-react";
import TenantLogo from '../TenantLogo';
import SearchIcon from '@mui/icons-material/Search';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import Hamburger from './Hamburger';
import Collapse from '@mui/material/Collapse';
import PaymentIcon from '@mui/icons-material/Payment';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AccountButton from './navElements/accountButton';
import SignInButton from './navElements/signInButton';
import WishListButton from './navElements/wishListButton';

// Translations
import _useTranslate from '../../hooks/_useTranslate';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const TopBar = ({feathersStore, onClickSignIn})=> {

  let common = _useTranslate(feathersStore.language, "common");  

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showResponsiveArea, setShowResponsiveArea] = useState(false);
  // NOTE: there is deliberately no showLoginBtn state here. One used to exist, set by an
  // effect as `flag && setShowLoginBtn(!flag)` - which only ever wrote false, never back to
  // true. It read as the login gate but nothing ever consumed it: the sign-in control is
  // gated inline below by `!feathersStore.tableQrOrderingOnly()`, which now re-evaluates on
  // its own when settings arrive. Removed rather than "fixed" so the next reader does not
  // trust a dead switch. Gate the button at its render site, not through mirrored state.

  const toggleSearchBar = () => {
    setShowSearchBar(oldVal => !oldVal);
  }

  const toggleResponsiveArea = () => {
    setShowResponsiveArea(oldValue => !oldValue);
  }

  // Logo choice: on phones prefer the customer's SQUARE logo when one exists
  // (stays compact instead of a wide logo eating half the bar); otherwise fall
  // back to the wide logo (which shrinks to fit). Desktop keeps the configured
  // useSquareWebLogo behavior.
  const { width } = useWindowDimensions();


  return (
    <div className="top-bar-sticky">
    <nav className="top-bar-nav" aria-label={common.mainMenu || "Main menu"}>
      <div className="logoMenu">
        <Link to="/" 
          //onClick={() => resetProducts()} 
          className="logoView" >
          <TenantLogo
            branding={feathersStore.branding}
            preferSquare={width <= 650}
            className="logo-img"
            squareClassName="logo-img-square"
            loading="eager"
          />
        </Link>
        <div className="logoMenuView">          
          {feathersStore.isAuthenticated && feathersStore.user?.firstname !== "default" ? 
          <SettingsMenu/>
          :
          !feathersStore.tableQrOrderingOnly()  && <LoginComponent onClick={onClickSignIn}/>
          }          
          {showSearchBar ? <SearchBar/> : null}  
          <div 
            aria-label='Search'
            className="search-toggle"         
            onClick={toggleSearchBar}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSearchBar(); } }}>
              <span><SearchIcon style={{ fontSize: 36 }}/></span>
          </div>               
          {/* Track-your-order: shown whenever an order was placed from this
              browser and is not finished yet. Driven by the persisted
              latestOrder, so it works for a GUEST too — no account needed. */}
          {!feathersStore.qrReadOnly() && feathersStore.latestOrder?.id &&
            <Link
              className="track-order-link"
              aria-label={common.trackOrder || 'Track order'}
              title={common.trackOrder || 'Track order'}
              to={`/order/${feathersStore.latestOrder.id}${feathersStore.latestOrder.token
                ? `?t=${encodeURIComponent(feathersStore.latestOrder.token)}` : ''}`}
            >
              <DeliveryDiningIcon style={{ fontSize: 30 }}/>
            </Link>
          }
          {!feathersStore.qrReadOnly() && <CartComponent cartQuantity={feathersStore.cartLength} /> }
          <ColorModeToggle />
          <div className="select-language">
            <LanguageButton showCaption={false}/>
          </div>
          <div className="nav-SignIn cart-container hamburger-show">
            <Hamburger aria-label='hamburger-menu' showResponsiveMenu={toggleResponsiveArea}/>
          </div>    
        </div>               
      </div>
    </nav>
    {!showResponsiveArea && <div className="divider-top"></div>}
    <Collapse sx={{width: '100%'}} in={showResponsiveArea}>  
      <div id="responsiveDiv" className="responsive-area">
        <div className="responsive-element">
          <SearchBar  />
        </div>
          {feathersStore.isAuthenticated && feathersStore.user?.firstname === "default" && !feathersStore.tableQrOrderingOnly() && 
            <div className="responsive-element">
              <SignInButton 
                displayText={common.signIn}
                onClickSignIn={onClickSignIn} 
                aria-labelledby='Sign in'
              />
          </div> 
          } 
          {feathersStore.isAuthenticated && feathersStore.user?.firstname !== "default" && !feathersStore.qrReadOnly() &&
            <>
              <div className="responsive-element">
                <AccountButton aria-labelledby='Account'/>
                </div>
              <div className="responsive-element">
                <WishListButton  displayText={common.favorites} aria-labelledby='Wishlist'/>
              </div>
            </>
          } 
          {feathersStore.restaurantOpen && !feathersStore.qrReadOnly() && feathersStore?.orderItem?.total !== 0 && feathersStore.restaurantOpen &&
            <Link to="/checkout" className="language-styling responsive-element checkout-button">
              <span className="nav-button-SignIn undecorated-link">
                <PaymentIcon className="calendar-icon" style={{ fontSize: 30 }}/>
                <span style={{marginLeft: "1vw"}}> {common.checkout}</span>
              </span>         
            </Link> 
          }       
        
          <div className="responsive-element">
            <button className="swipe-button" onClick={toggleResponsiveArea}>
              <KeyboardArrowUpIcon className="calendar-icon" style={{ fontSize: 30 }}/>
            </button>          
          </div>
      </div>   
    </Collapse>
    </div>
  );
  
}

export default inject('feathersStore')(observer(TopBar));
